import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "mx-auto max-w-2xl lg:max-w-7xl" }

import type { MediaElementProps } from "./MediaElementProps";
import { MediaType, type PageBlock } from "@/views/blocks/PageBlock.interface";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import Media from "@/views/blocks/shared/section/media/media/Media.vue";
import ScrollAnimation from "@/views/blocks/shared/section/animations/ScrollAnimation.vue";
import { computed } from "vue";
import HorizontalSpacing from "@/views/blocks/shared/section/layout/spacing/HorizontalSpacing.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MediaElement',
  props: {
    block: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

// Calculate dimensions based on maxWidth class
const mediaDimensions = computed(() => {
    const maxWidthClass = dataValues.value.formatting.data.maxWidth;

    let width: number;
    let height: number;

    switch (maxWidthClass) {
        case "max-w-2xl":
            width = 672;
            height = 378;
            break;
        case "max-w-3xl":
            width = 768;
            height = 432;
            break;
        case "max-w-4xl":
            width = 896;
            height = 504;
            break;
        case "max-w-5xl":
            width = 1024;
            height = 576;
            break;
        case "max-w-6xl":
            width = 1152;
            height = 648;
            break;
        case "max-w-7xl":
            width = 1280;
            height = 720;
            break;
        default:
            width = 1280;
            height = 720;
    }

    return { width, height };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScrollAnimation, { type: _ctx.scrollAnimationType }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        id: _ctx.block.webId,
        style: _normalizeStyle({
                backgroundColor: styleValues.value.background,
            })
      }, [
        _createVNode(HorizontalSpacing, {
          class: _normalizeClass([
                    dataValues.value.formatting.data.paddingTop,
                    dataValues.value.formatting.data.paddingBottom,
                ])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!dataValues.value.media.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    "field-name": "media"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                                'rounded-lg overflow-hidden',
                                dataValues.value.media.data.mediaType === _unref(MediaType).IFRAME &&
                                !dataValues.value.formatting.data.iframeHeight
                                    ? 'aspect-[16/9]'
                                    : '',
                                dataValues.value.formatting.data.elementAlign,
                                dataValues.value.formatting.data.maxWidth,
                            ])
                      }, [
                        _createVNode(Media, {
                          data: {
                                    src: dataValues.value.media.data.src,
                                    alt: dataValues.value.media.data.alt,
                                    mediaType: dataValues.value.media.data.mediaType,
                                    videoSrc: dataValues.value.media.data.videoSrc,
                                    videoAutoplay: dataValues.value.media.data.videoAutoplay,
                                    videoControls: dataValues.value.media.data.videoControls,
                                    videoLoop: dataValues.value.media.data.videoLoop,
                                    iframeSrc: dataValues.value.media.data.iframeSrc,
                                },
                          "image-width": mediaDimensions.value.width,
                          "image-height": mediaDimensions.value.height,
                          "video-width": mediaDimensions.value.width,
                          "video-height": mediaDimensions.value.height,
                          "iframe-height": dataValues.value.formatting.data.iframeHeight
                        }, null, 8, ["data", "image-width", "image-height", "video-width", "video-height", "iframe-height"])
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ], 12, _hoisted_1)
    ]),
    _: 1
  }, 8, ["type"]))
}
}

})